const getters = {
    homeActive:(state)=>state.app.homeActive,
    userInfo: state => state.user.userInfo,
    token:  state => state.user.token,
};
export default getters;
